export const GET_PAYMENTS_BY_WAY_PAYMENT    = 'GET_PAYMENTS_BY_WAY_PAYMENT';
export const GET_PAYMENTS_BY_CUSTOMERS      = 'GET_PAYMENTS_BY_CUSTOMERS';
export const GET_PAYMENTS_BY_TYPE_DOCUMENTS = 'GET_PAYMENTS_BY_TYPE_DOCUMENTS';
